import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Button.css';

import Utils from '../../../base/Utils';

import Loading from './../loading/Loading';

class Button extends Component {
    availableTypes = ['Normal', 'Bad', 'Clean Normal', 'Clean Discreet', 'Clean Disabled'];
    availableWeight = ['Default', 'Bold', 'Thin'];
    availableSizes = ['Big', /*'Medium',*/ 'Small'];
    availableStates = ['Active', 'Disabled'];
    
    render() {
        var text = this.props.text;
        var to = this.props.to || null;
        var loading = this.props.loading || false;
        var onClick = this.props.onClick || function(){ };
        var type = Utils.checkAvailability(this.availableTypes, this.props.type, true);
        var weight = Utils.checkAvailability(this.availableWeight, this.props.weight, true);
        var size = Utils.checkAvailability(this.availableSizes, this.props.size, true);
        var state = Utils.checkAvailability(this.availableStates, this.props.state);
        
        var classValue = "Button " + size + " " + state + " " + type + " " + weight;
        
        var html = <div className={classValue} onClick={onClick}>
        {(loading) ? <Loading type="Fill" /> : ''}{text}</div>;
        
        html = this.checkLink(html, to);
        
        return html;
    }
    
    checkLink(html, to) {
        if(to !== null) {
            if(to.substr(0, 1) === '/')
            return <Link to={to}>{html}</Link>;
            else if(to.substr(0, 4) === 'http')
            return <a href={to} target="_blank" rel="noopener noreferrer">{html}</a>;
        } else
        return html;
    }
}

export default Button;
